import { Component, Input, OnInit } from '@angular/core'
import { InlineEditDialogCellDirective } from '../inline-edit-dialog-cell'
import StringUtils from 'projects/jml-lib/src/lib/utils/string.utils'

@Component({
  selector: 'jml-lib-multiline-cell',
  templateUrl: './multiline-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class MultilineCellComponent extends InlineEditDialogCellDirective {
  filterTags = StringUtils.filterTags

  triggerEdit(editorType: string, readOnly: boolean) {
    this.openEditorDialog(editorType, readOnly)
  }
}
